var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 66,
    viewBox: "0 0 105 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1771_68140)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.03 -4.00129C105.03 20.4406 85.2487 40.2533 60.8488 40.2533C36.4489 40.2533 16.6675 20.4406 16.6675 -4.00129C16.6675 -28.4432 36.4489 -48.2559 60.8488 -48.2559C85.2487 -48.2559 105.03 -28.4432 105.03 -4.00129Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.03 55.9987C149.03 80.4406 129.249 100.253 104.849 100.253C80.4489 100.253 60.6675 80.4406 60.6675 55.9987C60.6675 31.5568 80.4489 11.7441 104.849 11.7441C129.249 11.7441 149.03 31.5568 149.03 55.9987Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 49,
    cy: 49,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 42.7341,
    cy: 56.2659,
    r: 2.26588,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 37.6699,
    cy: 61.0003,
    r: 1.26588,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75229 19.5023C7.13907 18.9051 5.86652 17.6328 5.27106 16.0192L5.02472 15.3543L4.77837 16.0192C4.1801 17.6328 2.90895 18.9051 1.29432 19.5023L0.629883 19.7483L1.29432 19.9949C2.90895 20.5915 4.1801 21.8631 4.77837 23.477L5.02472 24.1426L5.27106 23.477C5.86652 21.8631 7.13907 20.5915 8.75229 19.9949L9.41813 19.7483L8.75229 19.5023Z",
    fill: "#D6EED6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1771_68140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 66,
    fill: "white",
    transform: "translate(16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.ad3ddc4f196742ea3bea26aa9b99f100.svg";
export { ForwardRef as ReactComponent };